import React from 'react';
import PropTypes from 'prop-types';
import {TableWithPaper} from 'components/';
import {Search, Add, ImportExport} from '@material-ui/icons';
import {exportToCSV} from '@kbi/utility-library';
import {useSelector} from 'react-redux';

const TorchHoodMonthlyTable = ({data=[], openModal, handleViewRow}) => {
  const currentUser = useSelector(state => state.auth.currentUser);

  const monthlyTableProps = {
    data,
    columns: [
      {Header: 'Date', accessor: 'Date', type: 'datetime', datetimeFormat: 'MM/YYYY'},
      {Header: 'Meter Start', accessor: 'MeterStart', type: 'numeric'},
      {Header: 'Meter End', accessor: 'MeterEnd', type: 'numeric'},
      {Header: 'Total Hours', accessor: 'TotalHours', type: 'numeric'},
      {Header: 'Total Weight', accessor: 'WeightTotal', type: 'numeric'},
    ],
    sortInitial: [{id: 'Date', desc: true}],
    paginationInitialSize: 10,
    actionsPerRow: [
      {
        icon: Search,
        tooltip: 'View Month',
        onClick: ({rowData}) => handleViewRow(rowData),
      },
    ],
    title: 'Torchhood Monthly Data',
    actionsBar: [
      {
        icon: Add,
        buttonProps: {disabled: currentUser.roleEHS === 'CAPA User'},
        text: 'Add Daily Log',
        onClick: openModal,
      },
      {
        icon: ImportExport,
        text: 'Export Table',
        onClick: () => exportToCSV(data, [
          {Header: 'Date', accessor: 'Date', type: 'datetime', datetimeFormat: 'MM/YYYY'},
          {Header: 'Meter Start', accessor: 'MeterStart', type: 'numeric'},
          {Header: 'Meter End', accessor: 'MeterEnd', type: 'numeric'},
          {Header: 'Total Hours', accessor: 'TotalHours', type: 'numeric'},
          {Header: 'Total Weight', accessor: 'WeightTotal', type: 'numeric'},
        ]),
      },
    ],
  };

  return (
    <TableWithPaper {...monthlyTableProps} />
  );
};

TorchHoodMonthlyTable.propTypes = {
  data: PropTypes.array,
  openModal: PropTypes.func.isRequired,
  handleViewRow: PropTypes.func.isRequired,
};

export default TorchHoodMonthlyTable;
